/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react';
import {
    GoogleMap,
    Marker,
    useLoadScript,
    StreetViewPanorama
} from '@react-google-maps/api';
import getConfig from 'next/config';

import { ListingInteractiveMapProps } from './ListingInteractiveMap.types';
import { MapContainer, StyledError } from './ListingInteractiveMap.styles';

import HOME_ICON from 'public/assets/map/map-dynamic-small-purple-pin-ballon-with-outline.svg';

const ListingInteractiveMap = ({
    data,
    showStreetView = false
}: ListingInteractiveMapProps) => {
    if (!data?.location?.coordinates) {
        return null;
    }

    const { latitude, longitude } = data.location.coordinates;
    const { publicRuntimeConfig } = getConfig();

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: '',
        googleMapsClientId: publicRuntimeConfig.MAPS_CLIENT_ID,
        channel: 'Lex-LDP'
    });

    const homeLocationLatLng = {
        lat: latitude,
        lng: longitude
    } as google.maps.LatLngLiteral;

    const mapOptions = {
        streetViewControl: true,
        fullscreenControl: false,
        minZoom: 3,
        gestureHandling: 'greedy'
    } as google.maps.MapOptions;

    const streetViewOptions = {
        position: homeLocationLatLng,
        visible: showStreetView
    } as google.maps.StreetViewPanoramaOptions;

    if (loadError) {
        return (
            <StyledError isRegular size="7" color="text-body">
                We&apos;re having trouble connecting to Google Maps. Please
                check your internet connection and try again.
            </StyledError>
        );
    }

    const renderMap = () => (
        <MapContainer data-testid="listing-map-container">
            <GoogleMap
                center={homeLocationLatLng}
                zoom={15}
                options={mapOptions}
            >
                {showStreetView && (
                    <StreetViewPanorama options={streetViewOptions} />
                )}
                <Marker position={homeLocationLatLng} icon={HOME_ICON} />
            </GoogleMap>
        </MapContainer>
    );

    return isLoaded ? renderMap() : <span>Loading...</span>;
};

export default ListingInteractiveMap;
